export const importFromCsv = {
  importSuccessfully: 'Import id cards successfully!',
  importFailed: 'Import id cards failed!',
}
